import companyCatalogStore, * as CompanyCatalogStore from './companyCatalogStore';

export type CompanyCatalogModel = CompanyCatalogStore.CompanyCatalogModel;

export default companyCatalogStore;
